// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_contained__Lcjix {
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  transition: all 0.5s;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  padding: 4px 10px 4px 10px;
  border-radius: 4px;
  background: var(--Orange);
  color: var(--White);
  border: none; }
  .button_contained__Lcjix:hover {
    background: var(--SaddleBrown); }

.button_outlined__iztHn {
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  transition: all 0.5s;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  padding: 2px 10px 2px 10px;
  border-radius: 4px;
  color: var(--Orange);
  border: 2px solid var(--Gray88); }
  .button_outlined__iztHn:hover {
    background: var(--Gray88); }

.button_text__DPNnT {
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  transition: all 0.5s;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  padding: 4px 10px 4px 10px;
  border-radius: 4px;
  color: var(--Orange);
  border: none;
  background: initial; }
  .button_text__DPNnT:hover {
    background: var(--Gray88); }

.button_oval__Z7kTx {
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  transition: all 0.5s;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  padding: 4px 10px 4px 10px;
  border-radius: 16px;
  color: var(--HightEmphasis);
  border: none;
  background: var(--Gray88); }
  .button_oval__Z7kTx:hover {
    background: var(--Gray85); }

.button_disabled__nknnF {
  background: #FFD1B4; }
  .button_disabled__nknnF:hover {
    background: #FFD1B4; }

.button_gap__CkE91 {
  gap: 4px; }

.button_fullWidth__tNsiY {
  width: 100%; }
`, "",{"version":3,"sources":["webpack://./src/components/button/button.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAcA;EAVE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;ECoEpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDhEjB,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY,EAAA;EAPd;IASI,8BAA8B,EAAA;;AAIlC;EAvBE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;ECoEpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDnDjB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B,EAAA;EANjC;IAQI,yBAAyB,EAAA;;AAI7B;EAnCE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;ECoEpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDvCjB,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB,EAAA;EAPrB;IASI,yBAAyB,EAAA;;AAG7B;EA/CE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;ECgCpB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDSjB,0BAA0B;EAC1B,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB,EAAA;EAP3B;IASI,yBAAyB,EAAA;;AAI7B;EACE,mBAAmB,EAAA;EADrB;IAGI,mBAAmB,EAAA;;AAIvB;EACE,QAAQ,EAAA;;AAGV;EACE,WAAW,EAAA","sourcesContent":["@import '../../styles/media.scss';\n@import '../../styles/fonts.scss';\n\n@mixin buttonBase {\n  width: fit-content;\n  height: fit-content;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  cursor: pointer;\n  transition: all 0.5s;\n}\n\n.contained {\n  @include buttonBase;\n  @include button;\n  padding: 4px 10px 4px 10px;\n  border-radius: 4px;\n  background: var(--Orange);\n  color: var(--White);\n  border: none;\n  &:hover {\n    background: var(--SaddleBrown);\n  }\n}\n\n.outlined {\n  @include buttonBase;\n  @include button;\n  padding: 2px 10px 2px 10px;\n  border-radius: 4px;\n  color: var(--Orange);\n  border: 2px solid var(--Gray88);\n  &:hover {\n    background: var(--Gray88);\n  }\n}\n\n.text {\n  @include buttonBase;\n  @include button;\n  padding: 4px 10px 4px 10px;\n  border-radius: 4px;\n  color: var(--Orange);\n  border: none;\n  background: initial;\n  &:hover {\n    background: var(--Gray88);\n  }\n}\n.oval {\n  @include buttonBase;\n  @include body2;\n  padding: 4px 10px 4px 10px;\n  border-radius: 16px;\n  color: var(--HightEmphasis);\n  border: none;\n  background: var(--Gray88);\n  &:hover {\n    background: var(--Gray85);\n  }\n}\n\n.disabled{\n  background: #FFD1B4;\n  &:hover{\n    background: #FFD1B4;\n  }\n}\n\n.gap {\n  gap: 4px;\n}\n\n.fullWidth {\n  width: 100%;\n}","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contained": `button_contained__Lcjix`,
	"outlined": `button_outlined__iztHn`,
	"text": `button_text__DPNnT`,
	"oval": `button_oval__Z7kTx`,
	"disabled": `button_disabled__nknnF`,
	"gap": `button_gap__CkE91`,
	"fullWidth": `button_fullWidth__tNsiY`
};
export default ___CSS_LOADER_EXPORT___;
